var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigBlueDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 2.83333,
    fill: "#5078C8",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 2.83333,
    stroke: "#5078C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C14.6739 30 13.4021 29.4732 12.4645 28.5355C11.5268 27.5979 11 26.3261 11 25V22C11 21.7348 11.1054 21.4804 11.2929 21.2929C11.4804 21.1054 11.7348 21 12 21C12.2652 21 12.5196 21.1054 12.7071 21.2929C12.8946 21.4804 13 21.7348 13 22V25C13 25.7956 13.3161 26.5587 13.8787 27.1213C14.4413 27.6839 15.2044 28 16 28H26C26.7956 28 27.5587 27.6839 28.1213 27.1213C28.6839 26.5587 29 25.7956 29 25V22C29 21.7348 29.1054 21.4804 29.2929 21.2929C29.4804 21.1054 29.7348 21 30 21C30.2652 21 30.5196 21.1054 30.7071 21.2929C30.8946 21.4804 31 21.7348 31 22V25C31 26.3261 30.4732 27.5979 29.5355 28.5355C28.5979 29.4732 27.3261 30 26 30H16Z",
    fill: "#5078C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7166 18.9C26.8086 18.9939 26.8811 19.105 26.93 19.227C26.979 19.349 27.0034 19.4794 27.0019 19.6108C27.0004 19.7422 26.9731 19.8721 26.9214 19.9929C26.8697 20.1137 26.7947 20.2232 26.7006 20.315L22.2006 24.715C22.0138 24.8976 21.7629 24.9999 21.5016 24.9999C21.2404 24.9999 20.9895 24.8976 20.8026 24.715L16.3026 20.315C16.2067 20.2237 16.1299 20.1142 16.0766 19.993C16.0234 19.8717 15.9947 19.7411 15.9923 19.6087C15.99 19.4763 16.0139 19.3447 16.0628 19.2216C16.1117 19.0986 16.1845 18.9864 16.2771 18.8917C16.3697 18.797 16.4802 18.7217 16.6021 18.67C16.7241 18.6183 16.855 18.5914 16.9875 18.5908C17.1199 18.5902 17.2511 18.6159 17.3736 18.6664C17.496 18.7169 17.6072 18.7912 17.7006 18.885L20.5016 21.624V13C20.5016 12.7348 20.607 12.4804 20.7945 12.2929C20.982 12.1054 21.2364 12 21.5016 12C21.7668 12 22.0212 12.1054 22.2087 12.2929C22.3963 12.4804 22.5016 12.7348 22.5016 13V21.624L25.3016 18.885C25.3955 18.7931 25.5067 18.7205 25.6286 18.6716C25.7506 18.6226 25.881 18.5982 26.0124 18.5997C26.1439 18.6012 26.2737 18.6285 26.3945 18.6803C26.5154 18.732 26.6248 18.807 26.7166 18.901V18.9Z",
    fill: "#5078C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigBlueDownloadIcon);
export default __webpack_public_path__ + "static/media/BigBlueDownloadIcon.a88d51dfe7113bf16dea5dfbe4ffcbdc.svg";
export { ForwardRef as ReactComponent };